import AuthStore from "./AuthStore";
import CartStore from "./CartStore";
import WishlistStore from "./WishlistStore";
import ProductPopupStore from "./ProductPopupStore";
import GlobalPopupStore from "./GlobalPopupStore";
import GeoBlockStore from "./GeoBlockStore";

export const authStore = new AuthStore();
export const cartStore = new CartStore();
export const wishlistStore = new WishlistStore();
export const productPopupStore = new ProductPopupStore();
export const globalPopupStore = new GlobalPopupStore();
export const geoBlockStore = new GeoBlockStore();
